export function setDomainHint(domainHint: string | null) {
    if (!domainHint) return;
    localStorage.setItem('domainHint', domainHint);
}
export function fetchDomainHint() {
    const domainHint = localStorage.getItem('domainHint');
    return domainHint ?? undefined;
}

